// src/components/legal-landing/legal-landing.tsx
function _define_property(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function _object_spread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            _define_property(target, key, source[key]);
        });
    }
    return target;
}
function ownKeys(object, enumerableOnly) {
    var keys = Object.keys(object);
    if (Object.getOwnPropertySymbols) {
        var symbols = Object.getOwnPropertySymbols(object);
        if (enumerableOnly) {
            symbols = symbols.filter(function(sym) {
                return Object.getOwnPropertyDescriptor(object, sym).enumerable;
            });
        }
        keys.push.apply(keys, symbols);
    }
    return keys;
}
function _object_spread_props(target, source) {
    source = source != null ? source : {};
    if (Object.getOwnPropertyDescriptors) {
        Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
    } else {
        ownKeys(Object(source)).forEach(function(key) {
            Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
        });
    }
    return target;
}
function _tagged_template_literal(strings, raw) {
    if (!raw) {
        raw = strings.slice(0);
    }
    return Object.freeze(Object.defineProperties(strings, {
        raw: {
            value: Object.freeze(raw)
        }
    }));
}
function _templateObject() {
    var data = _tagged_template_literal([
        "\n  query ConsentMgmtQuery($context: ContextInput!, $needEditorial: Boolean!) {\n    consentMgmtPage(context: $context, needEditorial: $needEditorial) {\n      card {\n        editorial {\n          ... on EGDSTextSection {\n            contents {\n              ... on EGDSPlainText {\n                ...EGDSPlainTextFragment\n              }\n            }\n          }\n        }\n        button {\n          ... on UIPrimaryButton {\n            analytics {\n              ... on ClientSideAnalytics {\n                eventType\n                linkName\n                referrerId\n                uisPrimeMessages {\n                  messageContent\n                  schemaName\n                }\n              }\n            }\n            disabled\n            primary\n          }\n        }\n      }\n    }\n  }\n\n  fragment EGDSPlainTextFragment on EGDSPlainText {\n    text\n  }\n"
    ]);
    _templateObject = function _templateObject() {
        return data;
    };
    return data;
}
import React from "react";
import { gql, useQuery } from "@apollo/client";
import { useBexApi } from "@shared-ui/bex-api-context";
import { useClickTracker } from "@shared-ui/clickstream-analytics-context";
import { SystemEvent, SystemEventLevel, useLoggerEvents } from "@shared-ui/logger-context";
import { UitkPrimaryButton } from "uitk-react-button";
import { UitkCard, UitkCardContentSection } from "uitk-react-cards";
import { UitkSpacing } from "uitk-react-spacing";
import { UitkText } from "uitk-react-text";
var __Query = gql(_templateObject());
var LogEvents = {
    ERROR_LOAD_OT_NOT_DEFINED_ON_INIT: new SystemEvent(SystemEventLevel.WARN, "ERROR_LOAD_OT_NOT_DEFINED_ON_INIT")
};
var LegalLanding = function(props) {
    var _data_consentMgmtPage_card_editorial;
    var inputs = props.inputs, skipSsr = props.skipSsr, onClick = props.onClick;
    var context = useBexApi().context;
    var systemEvents = useLoggerEvents(LogEvents);
    var clickTracker = useClickTracker();
    React.useEffect(function() {
        if (!window.OneTrust) {
            systemEvents.ERROR_LOAD_OT_NOT_DEFINED_ON_INIT.log("Error Load One Trust On Init");
        }
    });
    var variables = _object_spread_props(_object_spread({}, inputs), {
        context: context
    });
    var _useQuery = useQuery(__Query, {
        variables: variables,
        ssr: !skipSsr
    }), data = _useQuery.data, error = _useQuery.error, loading = _useQuery.loading;
    if (loading || error || !data) {
        return null;
    }
    var togglePopUp = function() {
        var _window_OneTrust, _window;
        if (onClick) {
            onClick();
        } else if ((_window = window) === null || _window === void 0 ? void 0 : (_window_OneTrust = _window.OneTrust) === null || _window_OneTrust === void 0 ? void 0 : _window_OneTrust.ToggleInfoDisplay) {
            window.OneTrust.ToggleInfoDisplay();
        }
    };
    var analytics = data.consentMgmtPage.card.button.analytics;
    var trackAnalytics = function() {
        if (analytics !== null) {
            clickTracker(analytics.referrerId, analytics.linkName);
        }
    };
    return /* @__PURE__ */ React.createElement(UitkCard, {
        border: true,
        backgroundTheme: "secondary"
    }, /* @__PURE__ */ React.createElement(UitkSpacing, {
        id: "top",
        padding: {
            inline: "six",
            blockstart: "six"
        }
    }, /* @__PURE__ */ React.createElement(UitkCardContentSection, null, (_data_consentMgmtPage_card_editorial = data.consentMgmtPage.card.editorial) === null || _data_consentMgmtPage_card_editorial === void 0 ? void 0 : _data_consentMgmtPage_card_editorial.contents.map(function(content, index) {
        return /* @__PURE__ */ React.createElement(UitkText, {
            size: 300,
            key: index,
            spacing: "four"
        }, content.text);
    }))), /* @__PURE__ */ React.createElement(UitkSpacing, {
        id: "bottom",
        padding: {
            inline: "four",
            blockstart: "six",
            blockend: "six"
        }
    }, /* @__PURE__ */ React.createElement(UitkCardContentSection, null, /* @__PURE__ */ React.createElement(UitkPrimaryButton, {
        onClick: togglePopUp,
        onClickCapture: trackAnalytics
    }, data.consentMgmtPage.card.button.primary))));
};
LegalLanding.displayName = "sharedui-LegalLanding";
export { LegalLanding };
//# sourceMappingURL=index.js.map